import React, { useState, useEffect } from 'react';

export default function LMDivisionPlayerDetail(props) {
	return <div>Player detail</div>;
}
